/**
 * Created by intellicar-rinas on 21/9/17.
 */

import mil from '../../../assets/svg/mil.svg';
import nonCommunicating from '../../../assets/svg/nonCommunicating.svg';
import noLocation from '../../../assets/svg/noLocation.svg';
import lat_long_0 from '../../../assets/svg/lat_long_0.svg';
import devicePullout from '../../../assets/svg/devicePullout.svg';
import chargingIcon from '../../../assets/svg/charging.svg';
import engTemp from '../../../assets/svg/engtemp.svg';
import {save, get} from '../../../helpers/helperFunctions';
import VehicleAPIs from '../../../APIs/VehicleAPIs';
import delay1818 from '../../../assets/svg/delay1818.svg';
import noSignal from '../../../assets/svg/no_signal2.svg'
import immob_pullout from '../../../assets/svg/immob_pullout.svg'


let carBatteryThreshold = parseFloat(get('cbt') || 3, 10); 
let lowBatteryThreshold = parseFloat(get('lbt') || 9.5, 10); 

window.statsSettings = {
    carBatteryThreshold,
    lowBatteryThreshold
}

window.resetStats =()=> {
    save('cbt', null);
    save('lbt', null);
    window.location.reload();
}

window.setStats =(cbt, lbt)=> {
    save('cbt', cbt);
    save('lbt', lbt);
    window.location.reload();
}

const isAssetValid =asset=> {
    return asset && asset.stats;
}

const isUser =vehicle=> {
    return vehicle.type == 'user';
}

const isVehicle =vehicle=> {
    return !isUser(vehicle);
}

const isMoving =vehicle=> {
    return vehicle.stats.speed >= 5;
}

const isMobilized =vehicle=> {
    return vehicle.stats.mobilistatus === 0;
}

const isTampered =vehicle=> {
    return vehicle.stats.tampered === 1;
}

const isTrackerComm =vehicle=> {
    return vehicle.stats.nocomm == 0;
}

const isKleComm =vehicle=> {
    return vehicle.stats.klenc == 0;
}

const isComm =vehicle=> {
    return isTrackerComm(vehicle);
}

const isIgnitionOn =vehicle=> {
    return vehicle.stats.ignitionstatus > 0;
}

const isCarBatteryLow =vehicle=> {
    return vehicle.stats.carbattery < carBatteryThreshold;
}

const isCarBatteryLowInverse =vehicle=> {
    return vehicle.stats.carbattery  >= carBatteryThreshold;
}

const isAssetTracker =vehicle=> {
    return vehicle.deviceTypesList.indexOf('concox_assettracker') !== -1 ||
    vehicle.deviceTypesList.indexOf('concox_at4') !== -1;
}

const isMIL =vehicle=> {
    return vehicle.stats.mil > 0;
}

const isHeated =vehicle=> {
    return vehicle.stats.enginetemp > 0;
}



export default [

    // All Vehicles
    {key:'allvehicles', name:'All Vehicles',iconType:'class', icon:'lnr lnr-eye', override:vehicle=>{
        return isAssetValid(vehicle) && isVehicle(vehicle);
    }},


    // Running
    {key:'running', name:'Running',iconType:'class', color:'green', icon:'lnr lnr-car', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            if(isAssetTracker(vehicle)) {
                return vehicle.stats.devicebattery > 20 && 
                    isMoving(vehicle) && 
                    (isComm(vehicle) || vehicle.stats.carbattery  <= carBatteryThreshold) && 
                    !isTampered(vehicle);
            }
            return isIgnitionOn(vehicle) &&  
                isMobilized(vehicle) &&  
                (vehicle.stats.carbattery  >= carBatteryThreshold) &&
                (isComm(vehicle)) && 
                !isTampered(vehicle);
        }
    }},


    // Stopped
    {key:'stopped', name:'Stopped',iconType:'class', color:'blue', icon:'lnr lnr-power-switch', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            if(isAssetTracker(vehicle)) {
                return vehicle.stats.devicebattery > 20 && 
                    !isMoving(vehicle) && 
                    (isComm(vehicle) || vehicle.stats.carbattery  <= carBatteryThreshold) && 
                    !isTampered(vehicle) &&
                    vehicle.stats.carbattery == 0;
            }
            return !isIgnitionOn(vehicle) &&  
                isMobilized(vehicle) &&  
                (vehicle.stats.carbattery  >= carBatteryThreshold) &&
                (isComm(vehicle)) && 
                !isTampered(vehicle);
        }
    }},


    // Immobilized
    {key:'immobilized', name:'Immobilized',iconType:'class', color:'red', icon:'lnr lnr-lock', override:vehicle=> {
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return !isMobilized(vehicle) &&
                // !isCarBatteryLow(vehicle)
                !isTampered(vehicle)
        }        
    }},


    /*
    *   Device pull-out will have higher priority than the non-communication bucket, what ever is a pull-out will 
    *   fall into device pull-out bucket and nocomm will never have a pullout vehicle 
    */

    // Non Communicating
    {key:'nocomm', name:'Non Communicating',iconType:'svg', icon:nonCommunicating, override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            // if(isAssetTracker(vehicle)) {
            //     return vehicle.stats.devicebattery > 20 && 
            //         isMobilized(vehicle) && 
            //         !isComm(vehicle) && 
            //         !isTampered(vehicle);
            // }
            return isCarBatteryLowInverse(vehicle) && 
                isMobilized(vehicle) && 
                !isComm(vehicle) &&   
                !isTampered(vehicle);
        }
    }},

    {key:'nocomm_2', name:'Non Communicating',iconType:'svg', nocommnew: true, icon:noSignal, override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return isCarBatteryLowInverse(vehicle) && 
                isMobilized(vehicle) && 
                !isComm(vehicle) &&   
                !isTampered(vehicle);
        }
    }},

    // {key:'nocomm-battery-low', parent:'nocomm', name:'Battery Low', iconType:'svg', icon:nonCommunicating, override:vehicle=>{
    //     if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
    //         return vehicle.stats.carbattery  >= carBatteryThreshold &&
    //             vehicle.stats.carbattery  < lowBatteryThreshold && 
    //             // vehicle.stats.devicebattery  < devBatteryThreshold && 
    //             !isAssetTracker(vehicle) && 
    //             isMobilized(vehicle) && 
    //             !isComm(vehicle) &&   
    //             // isKleComm(vehicle) &&   
    //             !isTampered(vehicle);
    //     }
    // }},

    // {key:'nocomm-others', parent:'nocomm', name:'Others', iconType:'svg', icon:nonCommunicating, override:vehicle=>{
    //     if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
    //         return isCarBatteryLowInverse(vehicle) &&
    //             !isAssetTracker(vehicle) && 
    //             isMobilized(vehicle) && 
    //             !isComm(vehicle) &&   
    //             // isKleComm(vehicle) &&   
    //             !isTampered(vehicle);
    //     }
    // }},


    {key:'nocomm-kle', name:'Non Communicating - KLE', iconType:'svg', icon:nonCommunicating, override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
            return isCarBatteryLowInverse(vehicle) &&
                !isAssetTracker(vehicle) && 
                isMobilized(vehicle) && 
                !isKleComm(vehicle) &&   
                !isTampered(vehicle);
        }
    }},

    {key:'nocomm-assettracker', name:'Non Communicating - Asset Tracker',iconType:'svg', icon:nonCommunicating, override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return isAssetTracker(vehicle) && 
                vehicle.stats.devicebattery > 20 && 
                isMobilized(vehicle) && 
                !isComm(vehicle) && 
                !isTampered(vehicle);
        }
    }}, 

    // Device Pullout
    {key:'devicepullout', name:'Device Pullout', iconType:'svg', icon:devicePullout,  override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
            return  !isAssetTracker(vehicle) &&  
                    isCarBatteryLow(vehicle) &&
                    isMobilized(vehicle) &&
                    !isTampered(vehicle);
        }
    }},
    {key:'immobpullout', name:'Immob Pullout', iconType:'svg', icon:immob_pullout,  override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
            return  !isAssetTracker(vehicle) &&  
                    isCarBatteryLow(vehicle) &&
                    isMobilized(vehicle) &&
                    !isTampered(vehicle);
        }
    }},


    // {key:'devicepullout-comm', parent:'devicepullout', name:'Communicating', iconType:'svg', icon:devicePullout,  override:vehicle=>{
    //     if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
    //         return  !isAssetTracker(vehicle) && 
    //                 isCarBatteryLow(vehicle) &&
    //                 isComm(vehicle) && 
    //                 isMobilized(vehicle) &&
    //                 !isTampered(vehicle);
    //     }
    // }},

    // {key:'devicepullout-non-comm', parent:'devicepullout', name:'Non Communicating', iconType:'svg', icon:devicePullout,  override:vehicle=>{
    //     if(isAssetValid(vehicle) && isVehicle(vehicle)) { 
    //         return  !isAssetTracker(vehicle) &&  
    //                 isCarBatteryLow(vehicle) &&
    //                 !isComm(vehicle) && 
    //                 isMobilized(vehicle) &&
    //                 !isTampered(vehicle);
    //     }
    // }},
 

     // CoolantTemp
     {key:'heatedeng', name:'Overheated Engine',iconType:'svg', icon:engTemp, override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  isHeated(vehicle);
        }
    }},

 

    // MIL
    {key:'mil', name:'MIL',iconType:'svg', icon:mil, override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  isMIL(vehicle)
        }
    }},


    // Tampered
    {key:'tampered', name:'Tampered',iconType:'text', color:'yellow', icon:'T', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  isTampered(vehicle)
        }
    }},


    //Bad Battery Health
    {key:'badBatteryHealth', name:'Very Bad Battery',iconType:'text', color:'red', icon:'B', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  (vehicle.batteryHealth && vehicle.batteryHealth.cond1 == 1);
        }
    }},

    {key:'badBatteryHealth-bad', parent:'badBatteryHealth', name:'Bad Battery',iconType:'text', color:'orange', icon:'B', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  (vehicle.batteryHealth && vehicle.batteryHealth.cond1 == 2);
        }
    }},

    {key:'badBatteryHealth-avg', parent:'badBatteryHealth', name:'Average Battery',iconType:'text', color:'yellow', icon:'B', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  (vehicle.batteryHealth && vehicle.batteryHealth.cond1 == 4);
        }
    }},


    {key:'badBatteryHealth-good', parent:'badBatteryHealth', name:'Good Battery',iconType:'text', color:'green', icon:'B', override:vehicle=>{
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  (vehicle.batteryHealth && vehicle.batteryHealth.cond1 == 6);
        }
    }},


    // Concox Asset Tracker Charging
    {key:'concox_assettracker_charging', name:'Charging',iconType:'svg', icon:chargingIcon, override:vehicle=>{
        if(isAssetValid(vehicle) && isAssetTracker(vehicle) && isVehicle(vehicle)) {
            return  vehicle.stats.carbattery > 0;
        }
    }},


    //Users
    {key:'users', name:'Users',iconType:'text', color:'yellow', icon:'U',  override: user=> {
        return isAssetValid(user)  && isUser(user); 
    }},
    {key:'users_moving', name:'Users Moving',iconType:'text', color:'green', icon:'M',  override: user=> {
        if(isAssetValid(user) && isUser(user)) {
            return  user.stats.speed > 5;
        }
    }},
    {key:'users_stopped', name:'Users Stopped',iconType:'text', color:'blue', icon:'S',  override: user=> {
        if(isAssetValid(user) && isUser(user)) {
            return  user.stats.speed < 5;
        }
    }},
    {key:'users_charging', name:'Users Charging',iconType:'svg', icon:chargingIcon,  override: user=> {
        if(isAssetValid(user) && isUser(user)) {
            return  user.stats.chargingStatus > 0;
        }
    }},


    {key:'rectification', name:'Rectification Required',iconType:'text', icon:'R', color: 'red', override: vehicle=> {
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  (vehicle.filters||[]).length === 1;
        }
    }},


    {key:'panicButton', name:'Panic Button',iconType:'text', icon:'PB', color: 'red', vehicleList: true, override: vehicle=> {
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  vehicle.stats.panicButton;
        }
    }},
    {key:'apiSubExpired', name:'API Subscription Expired ',iconType:'svg', icon:delay1818,  vehicleList: true, override: vehicle=> {
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            console.log(vehicle.stats)
            return  vehicle;
        }
    }},

    {key:'location-zero', name:'No GPS Fix ',iconType:'svg', icon:lat_long_0,  vehicleList: true, override: vehicle=> {
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            console.log(vehicle.stats)
            return  vehicle;
        }
    }},
    {key:'never-comm-gps', name:'Location Never Received',iconType:'svg', icon:noLocation,  vehicleList: true, override: vehicle=> {
        if(isAssetValid(vehicle) && isVehicle(vehicle)) {
            return  vehicle;
        }
    }},
];


